import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { CircularProgress } from "@mui/material";
import MessageIcon from "@mui/icons-material/Message";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import DeleteIcon from "@mui/icons-material/Delete";
import MiniButton from "../../components/MiniButton";
import { colorsList } from "../../data/colorsList";
import flagicon from "../../images/flag.png";
import BlankTr from "./BlankTr";

const firstStyle = ({ isFirst, index, paddingTop = 5 }) => {
  return isFirst && index > 0
    ? {
        borderTop: "solid 2px " + colorsList.darkGrey,
        paddingTop,
      }
    : {};
};

export default function AddressLine({
  index,
  data,
  getFeat,
  points_layer,
  address,
  handleClickAddr,
  focusPoint,
  updateCheck,
  closeGPS,
  goTo,
  focusLayer,
  openWindow,
}) {
  const isFirst = !(
    index > 0 && Number(address.list[index - 1].PUNTO) === Number(data.PUNTO)
  );
  return (
    <>
      {isFirst && <BlankTr />}
      <tr valign="top">
        <td
          align="center"
          style={{
            position: "relative",
            width: 40,
            ...firstStyle({ isFirst, index }),
          }}
        >
          {isFirst && (
            <MiniButton
              title={data.PP === 0 ? null : data.PP}
              image={data.PP === 0 ? { src: flagicon, alt: "flag" } : null}
              color={data.PP === 0 ? colorsList.white : colorsList.blue}
              titleColor={colorsList.white}
              onClick={() => {
                handleClickAddr(`p${index}`, false, () => {
                  focusPoint(getFeat(data.PUNTO, points_layer));
                });
              }}
              iconSize={20}
              style={{
                padding: 5,
                width: "auto",
                borderRadius: 50,
                marginLeft: 5,
                marginRight: 5,
              }}
            />
          )}
        </td>
        <td
          style={{
            width: 30,
            paddingTop: 3,
            ...firstStyle({ isFirst, index, paddingTop: isFirst ? 8 : null }),
          }}
        >
          {Number(data.EST) === 0 ? (
            <CheckBoxOutlineBlankIcon
              style={{ cursor: "pointer" }}
              onClick={() => {
                updateCheck("EST", {
                  index,
                  data,
                  value: 1,
                });
              }}
            />
          ) : Number(data.EST) === -1 ? (
            <CircularProgress size={24} />
          ) : (
            <CheckBoxIcon
              style={{ color: "#289315", cursor: "pointer" }}
              onClick={() => {
                updateCheck("EST", {
                  index,
                  data,
                  value: 0,
                });
              }}
            />
          )}
        </td>
        <td
          style={{
            textAlign: "left",
            fontSize: 20,
            width: "100%",
            ...firstStyle({ isFirst, index }),
          }}
          onClick={
            () => {
              handleClickAddr(
                "e" + index,
                () => {
                  closeGPS();
                  goTo(
                    focusLayer({ id: data.PUNTO }, "coords", points_layer),
                    true
                  );
                },
                () => {
                  openWindow(index, data);
                }
              );
            } //;
            //closeGPS();
            //goTo(focusLayer({ id: data.PUNTO }, "coords", points_layer), true);
          }
          // onDoubleClick={(e) => {
          //   openWindow(index, data);
          // }}
        >
          {data.NOTAS !== "" && (
            <span style={{ position: "relative", height: 4 }}>
              <MessageIcon
                style={{
                  position: "absolute",
                  color: "#FF5900",
                  fontSize: 20,
                }}
              />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          )}
          {Number(data.EST) === 3 ? (
            <span style={{ textDecoration: "line-through" }}>{data.NOM}</span>
          ) : (
            data.NOM
          )}
          {data.OBSER !== "" ? (
            <p style={{ margin: 0, fontSize: 14 }}>{"(" + data.OBSER + ")"}</p>
          ) : (
            <></>
          )}
        </td>
        <td style={{ ...firstStyle({ isFirst, index }) }}>
          <MiniButton
            Icon={PersonOffIcon}
            onClick={() => updateCheck("EST", { index, data, value: 2 })}
            iconSize={25}
            color={colorsList.white}
            iconColor={colorsList[Number(data.EST) === 2 ? "red" : "darkGrey"]}
          />
        </td>
        <td style={{ ...firstStyle({ isFirst, index }) }}>
          <MiniButton
            Icon={DeleteIcon}
            onClick={() => updateCheck("EST", { index, data, value: 3 })}
            iconSize={25}
            color={colorsList.white}
            iconColor={colorsList[Number(data.EST) === 3 ? "red" : "darkGrey"]}
          />
        </td>
      </tr>
    </>
  );
}
